import { z } from "zod";
import { CustomerId } from "../fsm/fsm.schema.ts";
import { MaterialCategory, MaterialTranslations } from "./materials.schema.ts";
import { MaterialImageInputFields } from "./materials-image.schema.ts";

export const CreateMaterialInput = z
  .object({
    customerId: CustomerId.optional(), // BEL-730 — see createMaterial
    name: z.string().min(1),
    category: MaterialCategory,
    clientCost: z.number().nonnegative(),
    unit: z.string().optional(),
    sku: z.string().optional(),
    isConsumable: z.boolean().default(false),
    translations: MaterialTranslations.optional(),
  })
  .merge(MaterialImageInputFields);

export type CreateMaterialInput = z.infer<typeof CreateMaterialInput>;

export const UpdateMaterialInput = z
  .object({
    name: z.string().min(1).optional(),
    category: MaterialCategory.optional(),
    clientCost: z.number().nonnegative().optional(),
    unit: z.string().nullable().optional(),
    sku: z.string().nullable().optional(),
    isConsumable: z.boolean().optional(),
    translations: MaterialTranslations.nullable().optional(),
  })
  .merge(MaterialImageInputFields);

export type UpdateMaterialInput = z.infer<typeof UpdateMaterialInput>;
